<nav class="tw-px-4 tw-pb-2 tw-pt-4 tw-flex tw-items-center tw-gap-2 tw-overflow-x-auto">
    @for (name of order(); track $index) {
        @let title = collections()[name]?.title;
        @if (title) {
            <div (click)="gotoCollection.emit(name)"
                 class="tw-font-lexend tw-w-fit tw-whitespace-nowrap tw-h-9 tw-px-4 tw-flex tw-items-center tw-justify-center tw-rounded-2"
                 [class]="name === selectedCollection() ? 'tw-font-bold tw-bg-teal-200 tw-text-black' : 'tw-font-normal tw-bg-white tw-text-gray-500'">
                {{title}}</div>
        }
    }
</nav>